module.exports = __webpack_public_path__ + "img/a5.84f014f0.jpg";